import { OptionObj } from "@/types/interfaces/common";

// Filter options for dropdown filters
export const AGREEMENT_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { label: "Agent", value: "Agent" },
  { label: "Agent - Gold", value: "Agent - Gold" },
  { label: "Agent - Silver", value: "Agent - Silver" },
  { label: "Agent - Student 1", value: "Agent - Student 1" },
  { label: "Agent - Student 2", value: "Agent - Student 2" },
  { label: "Agency", value: "Agency" },
  { label: "Agency - Gold", value: "Agency - Gold" },
  { label: "Agency - Silver", value: "Agency - Silver" },
  { label: "Agency - Student 1", value: "Agency - Student 1" },
  { label: "Agency - Student 2", value: "Agency - Student 2" },
  { label: "Associate Agent", value: "Associate Agent" },
  { label: "Associate Agent - Good", value: "Associate Agent - Good" },
  { label: "Associate Agent - Better", value: "Associate Agent - Better" },
  { label: "Associate Agent - Best", value: "Associate Agent - Best" },
  { label: "Associate Agent - Bronze", value: "Associate Agent - Bronze" },
];

export const PROVINCE_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { label: "Alberta", value: "AB" },
  { label: "British Columbia", value: "BC" },
  { label: "Manitoba", value: "MB" },
  { label: "New Brunswick", value: "NB" },
  { label: "Newfoundland and Labrador", value: "NL" },
  { label: "Northwest Territories", value: "NT" },
  { label: "Nova Scotia", value: "NS" },
  { label: "Nunavut", value: "NU" },
  { label: "Ontario", value: "ON" },
  { label: "Prince Edward Island", value: "PE" },
  { label: "Quebec", value: "QC" },
  { label: "Saskatchewan", value: "SK" },
  { label: "Yukon", value: "YT" },
];

export const AGENT_TYPE_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { label: "Primary Agent", value: "PA" },
  { label: "Associate Agent", value: "AA" },
];

export const DISPLAY_SALES_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "N/A", value: "NA" },
];

export const MENTOR_PROGRAM_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { label: "Did Not Qualify", value: "DNQ" },
  { label: "Did Not Want", value: "DNW" },
  { label: "To Be Determined", value: "TBD" },
  { label: "No", value: "NO" },
  { label: "N/A", value: "NA" },
];

export const HAS_SABRE_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { label: "Sabre", value: "Sabre" },
  { label: "Apollo", value: "Apollo" },
  { label: "N/A", value: "NA" },
];

export const TOUR_OPS_INSURANCE_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
  { label: "N/A", value: "N/A" },
  { label: "Started After", value: "Started After" },
];

export const YES_NO_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];

export const STATUS_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { label: "New", value: "NEW" },
  { label: "Active", value: "ACTIVE" },
  { label: "Leaving", value: "LEAVING" },
  { label: "Resigned", value: "RESIGNED" },
];

export const EXPERTISE_LEVEL_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { value: "0", label: "Little" },
  { value: "1", label: "I am familiar" },
  { value: "2", label: "I Rock" },
  { value: "3", label: "I am all Star" },
];

export const YESNO_BOOLEAN: OptionObj[] = [
  { label: "All", value: "" },
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

export const CERTIFICATION_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { label: "I've no designation this time", value: "0" },
  { label: "Supplier - Designation", value: "1" },
  { label: "Celebrity Cruises - Five Star Agent", value: "2" },
  { label: "Globus - Globus Expert", value: "3" },
  { label: "Monograms - Monograms Expert", value: "4" },
  { label: "Avalon Waterways - Avalon Specialist", value: "5" },
  { label: "Cosmos - Cosmos Expert", value: "6" },
  { label: "Royal Caribbean - University of Wow Expert", value: "7" },
  { label: "Oceania - Oceania Cruise Specialist", value: "8" },
  { label: "Collette Vacations - Collette Specialist", value: "9" },
  { label: "Norwegian Cruise Line - NCL U Frestyle Certified Agent", value: "10" },
  { label: "Princess - Princess Commodore", value: "11" },
  { label: "Trafalgar - Trafalgar Specialist", value: "12" },
  { label: "Sandals - Certified Sandals Specialist", value: "13" },
  { label: "Rocky Mountaineer - Tracks Specialist", value: "14" },
  { label: "VIA Rail - VIA Rail Agent", value: "15" },
  { label: "G Adventures - G Learning", value: "16" },
  { label: "Viking River Cruises - Viking River Cruises Specialist", value: "17" },
  { label: "Rail Europe - Europen Rail Expert", value: "18" },
  { label: "Accredited Cruise Counsellor, CLIA", value: "19" },
  { label: "Luxury Cruise Certificate, CLIA", value: "20" },
];

export const FB_GROUPS_OPTIONS: OptionObj[] = [
  { label: "All", value: "" },
  { label: "DWS", value: "DWS" },
  { label: "TC18", value: "TC18" },
  { label: "SMEGOWAY", value: "SMEGOWAY" },
  { label: "SMEOC", value: "SMEOC" },
  { label: "SMEMG", value: "SMEMG" },
  { label: "SMEIVG", value: "SMEIVG" },
  { label: "SMETBD", value: "SMETBD" },
  { label: "SMEGA", value: "SMEGA" },
  { label: "SMEC", value: "SMEC" },
  { label: "SMERC", value: "SMERC" },
  { label: "TABTDT", value: "TABTDT" },
  { label: "TYQG", value: "TYQG" },
  { label: "TNON", value: "TNON" },
  { label: "TYOW", value: "TYOW" },
  { label: "TYYT", value: "TYYT" },
  { label: "TYHZ", value: "TYHZ" },
  { label: "TYYG", value: "TYYG" },
  { label: "TYFC", value: "TYFC" },
  { label: "TYXU", value: "TYXU" },
  { label: "TYQR", value: "TYQR" },
  { label: "TYWG", value: "TYWG" },
  { label: "TYYC", value: "TYYC" },
  { label: "TYEG", value: "TYEG" },
  { label: "TYVR", value: "TYVR" },
  { label: "TYYZ", value: "TYYZ" },
  { label: "CORAGMG", value: "CORAGMG" },
  { label: "MOREPROMOS", value: "MOREPROMOS" },
  { label: "LEADGEN", value: "LEADGEN" },
  { label: "TTALK", value: "TTALK" },
  { label: "TSANDBOX", value: "TSANDBOX" },
  { label: "MTPG", value: "MTPG" },
];
